export default "__VITE_ASSET__c7703cfb__"